import { useIntlShort } from "@moim/common";

export default function useGroupTexts(
  key: Moim.Group.GroupTextSetKey,
  values?: Record<string, string | number>,
) {
  const intl = useIntlShort();
  const text = {
    singular: intl(key, values),
    plural: intl(`${key}_plural`, values),
  };
  return text;
}
